<template>
  <div class="case-form">
    <div class="case-form-section">
      <b-row>
        <b-col xs="12" sm="12" md="7">
          <InputText :title="isNew && isBatch ? 'Prefixo do Nome' : 'Nome'" field="name" :formName="formName"
            :required="true" :maxLength="200" :markFormDirty="false" v-model="caseModel.name" />
        </b-col>
        <b-col xs="12" sm="12" md="5">
          <InputText title="Código" field="barCode" :formName="formName" :required="!isBatch" :maxLength="100"
            :disabled="isBatch" :markFormDirty="false" v-model="caseModel.barCode" />
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="6" v-if="showRfid && hasRule('RFID')">
          <InputText title="RFID" field="rfid" :formName="formName" :required="false" :maxLength="100"
            :disabled="isBatch" :markFormDirty="false" v-model="caseModel.rfid" />
        </b-col>
        <b-col xs="12" sm="12" md="6" v-if="!isNew">
          <RadioGroup title="Status" field="status" :formName="formName" :markFormDirty="false" :options="[
            { text: 'Ativo', value: 1 },
            { text: 'Inativo', value: 2 },
          ]" v-model="caseModel.status" />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <TextArea title="Descrição" field="description" :formName="formName" :required="false" :maxLength="2000"
            v-model="caseModel.description" />
        </b-col>
      </b-row>
    </div>

    <div class="case-form-divider" v-if="isNew"></div>

    <div class="case-form-section" v-if="isNew">
      <span class="case-form-section-title">Cadastro em Lote</span>
      <b-row>
        <b-col xs="12" sm="12" md="4">
          <InputNumber title="Quantidade de Cases" field="quantity" :formName="formName" :required="false"
            type="int" :markFormDirty="false" v-model="quantity" />
        </b-col>
      </b-row>
      <Alert type="info" class="case-form-alert" v-if="isBatch">
        Serão criadas <b>{{ quantity }}</b> cases nomeadas de
        <b>{{ caseModel.name }} 01</b> até <b>{{ caseModel.name }} {{ lastSequence }}</b>.
      </Alert>
    </div>

    <div class="case-form-divider"></div>

    <div class="case-form-footer">
      <Button _key="saveCase" type="success" title="Salvar" :disabled="!isFormValid(formName)" classIcon="fas fa-save"
        size="medium" :clicked="save" />
    </div>
  </div>
</template>

<script>
import Alert from "@/ui/layout/Alert";
import Button from "@/ui/forms/Button";
import InputText from "@/ui/forms/InputText";
import InputNumber from "@/ui/forms/InputNumber";
import RadioGroup from "@/ui/forms/RadioGroup";
import TextArea from "@/ui/forms/TextArea";

import Case from "../../models/Case";
import CaseService from "../../services/case.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "CaseForm",
  components: { Alert, Button, InputText, InputNumber, RadioGroup, TextArea },
  data() {
    return {
      formName: "caseForm",
      caseModel: new Case(),
      quantity: 1,
      showRfid: false,
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
    ...mapGetters("user", ["hasRule"]),
    isNew() {
      return !this.caseModel.id;
    },
    isBatch() {
      return this.isNew && this.quantity > 1;
    },
    lastSequence() {
      return String(this.quantity).padStart(2, "0");
    },
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "removeLoading", "hideModal"]),
    ...mapMutations("validation", ["resetValidation"]),
    async save() {
      try {
        if (this.caseModel.id) {
          await CaseService.update(this.caseModel);
          this.addEvent({ name: "caseUpdated" });
        } else if (this.isBatch) {
          await this.createBatch();
          this.addEvent({ name: "caseCreated" });
        } else {
          await CaseService.create(this.caseModel);
          this.addEvent({ name: "caseCreated" });
        }
        this.hideModal();
      } finally {
        this.removeLoading(["saveCase"]);
      }
    },
    async createBatch() {
      const prefix = this.caseModel.name;
      for (let i = 1; i <= this.quantity; i++) {
        const model = new Case();
        model.name = `${prefix} ${String(i).padStart(2, "0")}`;
        model.description = this.caseModel.description;
        await CaseService.create(model);
      }
    },
    resetForm() {
      this.resetValidation(this.formName);
      this.caseModel = new Case();
      this.quantity = 1;
    },
    populateForEdit(data) {
      this.resetValidation(this.formName);
      this.caseModel = new Case();
      this.caseModel.update(data);
      this.quantity = 1;
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name === "caseCreate") this.resetForm();
        if (event.name === "caseUpdate") this.populateForEdit(event.data);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.case-form-section {
  padding: 16px 0;
}

.case-form-section-title {
  display: block;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  margin-bottom: 14px;
}

.case-form-divider {
  border-top: 1px solid var(--border-subtle);
}

.case-form-alert {
  margin-top: 10px;
}

.case-form-footer {
  padding: 16px 0 4px;
  display: flex;
  justify-content: flex-end;
}
</style>
